import { render, staticRenderFns } from "./SpoiledToTop.vue?vue&type=template&id=53fbbe51&scoped=true&"
import script from "./SpoiledToTop.vue?vue&type=script&lang=js&"
export * from "./SpoiledToTop.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "53fbbe51",
  null
  
)

export default component.exports